import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MatchHistoryTable from './MatchHistoryTable';
import SortMatchesTable from './SortMatchesTable';

const SORT_GENERAL_VALUES = ["Date", "Win", "Loss"];
const SORT_MAPS_VALUES = [
  "All Maps",
  "Mirage",
  "Inferno",
  "Nuke",
  "Anubis",
  "Vertigo",
  "Ancient",
  "Cache",
  "Cobblestone",
  "Dust II",
];

const ProfileMatchHistoryTab = ({ 
  last25MatchData, 
  matchSummary,
  sortOptions,
  hasPlayedAtLeastOneMatch,
  onSortChange,
  isLoggedIn,
}) => {
  const matchNumber = matchSummary?.totalPlayedMatches ?? 0;

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '1.5rem',
          gap: '1rem',
          flexWrap: 'wrap',
        }}
      >
        <Typography
          sx={{
            fontSize: '1.5rem',
            fontWeight: 700,
            color: '#ffffff',
          }}
        >
          {matchNumber === 0
            ? "No matches played"
            : `Last ${matchNumber} match${matchNumber > 1 ? "es" : ""}`}
        </Typography>

        <Box sx={{ display: 'flex', gap: '1rem' }}>
          <SortMatchesTable 
            setSortOption={onSortChange("general")} 
            defaultSortOption="Date" 
            sortValues={SORT_GENERAL_VALUES}
          />
          <SortMatchesTable 
            setSortOption={onSortChange("map")} 
            defaultSortOption="All Maps" 
            sortValues={SORT_MAPS_VALUES}
          />
        </Box>
      </Box>
      
      <MatchHistoryTable
        rows={last25MatchData}
        areMatchesAvailable={hasPlayedAtLeastOneMatch}
        sortOptions={sortOptions}
        isLoggedIn={isLoggedIn}
      />
    </Box>
  );
};

ProfileMatchHistoryTab.propTypes = {
  last25MatchData: PropTypes.object,
  matchSummary: PropTypes.object,
  sortOptions: PropTypes.object,
  hasPlayedAtLeastOneMatch: PropTypes.bool.isRequired,
  onSortChange: PropTypes.func.isRequired,
  isLoggedIn: PropTypes.bool.isRequired,
};

export default ProfileMatchHistoryTab;
